export const environment = {
  production: true,
  statusesWithDelay: [2,3,83],
  statusesWithDelay2: [83],
  api: {
    baseUrl: 'https://schoolclosing.cablevision.com/scadminapi',
    singIn: '/secure/token',
    status: {
      all: '/api/status/all',
      filt: '/api/status/filt',
      delete: '/api/status/delete/{statusId}',
      upload: '/api/status/upload/{statusId}',
      play: '/api/status/play/{filename}',
      save: '/api/status/save',
      get: '/api/status/get/{statusId}'
    },
    state: '/api/state/all',
    county: '/api/county/by/state/{state}',
    district: '/api/district/by/county/{countyId}',
    region: {
      all: '/api/region/all',
      get: '/api/region/get/{regionId}'
    },
    adminSounds: {
      all: '/api/adminsounds/all/{regionId}',
      play: '/api/adminsounds/region/play/{regionId}/{filename}',
      deleteRegionSound: '/api/adminsounds/region/delete/{regionId}/{filename}',
      uploadSound: '/api/adminsounds/region/upload/{regionId}/{filename}'
    },
    switchStatusTimes: {
      get: '/api/switchstatustimes/get/{regionId}',
      save: '/api/switchstatustimes/save'
    },
    orgCategory: '/api/orgcategory/all',
    headend: '/api/headend/by/region/{regionId}',
    organizations: {
      filter: '/api/organization/filter/skip/{skip}/take/{take}',
      delete: '/api/organization/delete/{orgId}',
      get: '/api/organization/get/{orgId}',
      save: '/api/organization/save',
      sendSound: '/api/organization/{orgId}/upload/sound',
      playSound: '/api/organization/play/sound/{filename}',
      updateStatus: '/api/organization/status/update/{orgId}',
      getStatus: '/api/organization/status/get/{orgId}'
    },
    statusEndTimeRules: {
      add: '/api/statusendtimerules/add',
      save: '/api/statusendtimerules/save',
      get: '/api/statusendtimerules/get/{regionId}/skip/{skip}/take/{take}',
      count: '/api/statusendtimerules/count/{regionId}',
      delete:
        '/api/statusendtimerules/delete/{statusId}/{categoryId}/{regionId}'
    }
  }
};



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/environments/environment.ts